import * as Sentry from '@sentry/browser';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY,
});

const renderErrorScreen = ({ error }: any) => {
  return (
    <div className='errorBoundaryRoot'>
      <span className='errorBoundaryTitle'>Sorry!</span>
      <span className='errorBoundaryDescription'>
        Unfortunately, we have run into a technical issue
      </span>
      {process.env.REACT_APP_IS_MOCK === 'true' ? (
        <span>{error?.toString() ? error?.toString() : ''}</span>
      ) : null}
    </div>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <BrowserRouter >
    <ErrorBoundary fallback={renderErrorScreen}>
      <Routes>
        <Route path={'*'} element={<App />}></Route>
      </Routes>
    </ErrorBoundary>
  </BrowserRouter>
);
